import React, { Component } from 'react';
import { string, shape, number, object } from 'prop-types';
// This MultiTouch lib is used for 2-finger panning.
// which prevents user to experience map-scroll trap, while scrolling the page.
// https://github.com/mapbox/mapbox-gl-js/issues/2618
// TODO: we should add an overlay with text "use two fingers to pan".
import MultiTouch from 'mapbox-gl-multitouch';
import uniqueId from 'lodash/uniqueId';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';
// import 'mapbox-gl/src/css/mapbox-gl.css';


import { circlePolyline } from '../../util/maps';
import Map from './Map';
import Modal from '../Modal/Modal';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';






const mapMarker = () => {
  return new window.mapboxgl.Marker();
};

const circleLayer = (center, mapsConfig, layerId) => {
  const path = circlePolyline(center, mapsConfig.fuzzy.offset).map(([lat, lng]) => [lng, lat]);
  return {
    id: layerId,
    type: 'fill',
    source: {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [path],
        },
      },
    },
    paint: {
      'fill-color': mapsConfig.fuzzy.circleColor,
      'fill-opacity': 0.2,
    },
  };
};

const generateFuzzyLayerId = () => {
  return uniqueId('fuzzy_layer_');
};

class DynamicMapboxMap extends Component {
  constructor(props) {
    super(props);

    this.mapContainer = null;
    this.map = null;
    this.centerMarker = null;
    this.fuzzyLayerId = generateFuzzyLayerId();

    this.updateFuzzyCirclelayer = this.updateFuzzyCirclelayer.bind(this);
  }   

setAuthenticationModelState(isOpen){
  this.setState({
    ...this.state,
    isAuthenticationModelOpen: !!isOpen
  });
}
  componentDidMount() {
    const { center, zoom, mapsConfig,isAuthenticated } = this.props;
    const position = [center.lng, center.lat];

    document.addEventListener('click', this.handleDocumentClick);

    this.map = new window.mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/streets-v10',
      center: position,
      zoom,
      scrollZoom: false,
    });

    const destination=[center.lng, center.lat];
    this.map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-left');
    this.map.addControl(new MultiTouch());
//Direction styling
const link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.href = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-directions/v4.3.1/mapbox-gl-directions.css';
document.head.appendChild(link);

    this.map.on('load', () => {
        this.map.addControl(
          new MapboxDirections({
           accessToken: 'pk.eyJ1Ijoic2hhcmV0cmliZS1mbGV4LWRlcGxveW1lbnRzIiwiYSI6ImNsZ25tdWZscDBoMTQzZWpxbzZjaHh4dTIifQ.YJOztn-vz88JEtHLc815QA',
            placeholderOrigin: 'Choose your location',        
            
          }
          ).setDestination(destination),      
          'top-right');  
          
          var destinationInput = document.querySelector('.mapbox-directions-destination');
          destinationInput.style.display = 'none';
      });

    if (mapsConfig.fuzzy.enabled) {
      this.map.on('load', () => {
        this.map.addLayer(circleLayer(center, mapsConfig, this.fuzzyLayerId));
      });
    } else {
      this.centerMarker = mapMarker();
      this.centerMarker.setLngLat(position).addTo(this.map);
    }
  }
  componentWillUnmount() {
    if (this.map) {
      this.centerMarker = null;
      this.map.remove();
      this.map = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.map) {
      return;
    }

    const { center, zoom, mapsConfig } = this.props;
    const { lat, lng } = center;
    const position = [lng, lat];

    // zoom change
    if (zoom !== prevProps.zoom) {
      this.map.setZoom(this.props.zoom);
    }

    const centerChanged = lat !== prevProps.center.lat || lng !== prevProps.center.lng;

    // center marker change
    if (this.centerMarker && centerChanged) {
      this.centerMarker.setLngLat(position);
      this.map.setCenter(position);
    }

    // fuzzy circle change
    if (mapsConfig.fuzzy.enabled && centerChanged) {
      if (this.map.loaded()) {
        this.updateFuzzyCirclelayer();
      } else {
        this.map.on('load', this.updateFuzzyCirclelayer);
      }
    }

    // NOTE: mapsConfig changes are not handled
  }
  updateFuzzyCirclelayer() {
    if (!this.map) {
      // map already removed
      return;
    }
    const { center, mapsConfig } = this.props;
    const { lat, lng } = center;
    const position = [lng, lat];

    this.map.removeLayer(this.fuzzyLayerId);

    // We have to use a different layer id to avoid Mapbox errors
    this.fuzzyLayerId = generateFuzzyLayerId();
    this.map.addLayer(circleLayer(center, mapsConfig, this.fuzzyLayerId));

    this.map.setCenter(position);
  }

  handleDocumentClick = (event) => {
    const geocoderElement = event.target.closest('.mapboxgl-ctrl-geocoder');

    if (geocoderElement && !this.props.isAuthenticated) {
      this.setAuthenticationModelState(true);
      return <Redirect to='/login' />
    }
}

  
  render() {
    const { containerClassName, mapClassName } = this.props;

    return (
      <div className={containerClassName}>
        <div className={mapClassName} ref={el => (this.mapContainer = el)} />
        <Modal  
        isOpen={this.state?.isAuthenticationModelOpen}
        onClose={() => {
          window.open('/login');
          this.setAuthenticationModelState(false)   
        }       
        }
        onManageDisableScrolling={console.log}
        
      >
        
        <p>Please login to get details </p>  
      </Modal>
      </div>
    );
  }
}

DynamicMapboxMap.defaultProps = {
  address: '',
  center: null,
};

DynamicMapboxMap.propTypes = {
  address: string, // not used
  center: shape({
    lat: number.isRequired,
    lng: number.isRequired,
  }).isRequired,
  zoom: number.isRequired,
  mapsConfig: object.isRequired,
};

export default DynamicMapboxMap;
